import { observer } from 'mobx-react'
import { useEffect } from 'react'

import { useGetPinnedPipelineItemsCountForUser } from '@flowwai-frontend/bps-officer-web/common/data-access'

interface PropsType {
   children: React.ReactElement
}

const PinPipelineItemsCountController = (
   props: PropsType
): React.ReactElement => {
   const { children } = props

   const getPinnedPipelineItemsCountAPIObject = useGetPinnedPipelineItemsCountForUser()

   useEffect(() => {
      getPinnedPipelineItemsCountAPIObject.triggerAPI()
   }, [])

   return children
}

export default observer(PinPipelineItemsCountController)
